import { api, ApiError } from "@/api/api";
import { MaskWithImage } from "@/api/masks-types";
import { useQuery } from "@tanstack/react-query";

export function useEpisodeMasksByEpisodeId(episodeId: string | undefined) {
  return useQuery<{ masks: MaskWithImage[] }, ApiError>({
    queryKey: ["GET", "episodeDetails", episodeId, "masks"],
    queryFn: () => api.episodes.episodeId.masks.get({ episodeId: episodeId! }),
    enabled: !!episodeId,
  });
}
